import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    account: (state) => state.account,
  }),
  ...mapGetters('auth', ['isUserLoggedIn']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'resetPasswordAsync',
])
